import type { ReactNode } from 'react';

/**
 * On / off setting: the whole row is the switch (role="switch"), title and one line of help on the left, the
 * track on the right. `note` (e.g. why it cannot work yet) is announced with it.
 */
export function Switch({ checked, onChange, label, help, note, icon, disabled }: { checked: boolean; onChange: (next: boolean) => void; label: ReactNode; help?: ReactNode; note?: ReactNode; icon?: ReactNode; disabled?: boolean }) {
  return (
    <button type="button" role="switch" aria-checked={checked} className="switch-row" onClick={() => onChange(!checked)} disabled={disabled}>
      {icon && <span className="switch-icon" aria-hidden="true">{icon}</span>}
      <span className="switch-text">
        <span className="switch-label">{label}</span>
        {help && <span className="switch-help">{help}</span>}
        {note && <span className="switch-note">{note}</span>}
      </span>
      <span className="switch-track" aria-hidden="true">
        <span className="switch-thumb" />
      </span>
    </button>
  );
}
